import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "message", "status"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PT from 'prop-types';
import { intrinsicComponent } from '../../utils/functions';
import PopupStatus from '../popup-status';
import CrossButton from '../cross-button/cross-button.component';
import { defaultProps as popupStatusDefaultProps, propTypes as popupStatusPropTypes } from '../popup-status/popup-status.component';
import Styled from './popup-content.styles';
var PopupContent = intrinsicComponent(function (_ref, ref) {
  var onClose = _ref.onClose,
    message = _ref.message,
    status = _ref.status,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.PopupContent, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Styled.PopupStatus, _extends({
    status: status,
    message: message
  }, rest), /*#__PURE__*/React.createElement(PopupStatus, {
    status: status
  })), /*#__PURE__*/React.createElement(Styled.LabelWrapper, null, /*#__PURE__*/React.createElement(Styled.Label, null, message)), /*#__PURE__*/React.createElement(Styled.CloseWrapper, null, /*#__PURE__*/React.createElement(CrossButton, {
    size: "sm",
    onClick: onClose
  })));
});
export var defaultProps = _objectSpread({}, popupStatusDefaultProps);
PopupContent.defaultProps = defaultProps;
export var propTypes = _objectSpread(_objectSpread({}, popupStatusPropTypes), {}, {
  message: PT.node.isRequired,
  onClose: PT.func
});
PopupContent.propTypes = propTypes;
export default PopupContent;